import React from "react";
import { Layout, Typography, Steps, Row, Col, Card } from "antd";
import { SolutionOutlined, TeamOutlined, ReadOutlined, CheckCircleOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { Step } = Steps;

const OurProcess = () => {
  return (
    <Layout>
      <Content style={{ padding: "50px", background: "#f0f2f5" }}>
        <Title level={2} style={{ fontSize: "24px", color: "#1890ff", textAlign: "center" }}>
          Our Process
        </Title>
        <Paragraph style={{ fontSize: "16px", color: "#666", textAlign: "center", marginBottom: "30px" }}>
          At JectHub, we provide a structured and interactive approach to learning AI, Cybersecurity, and Data Science.
          Our process ensures users gain hands-on experience, mentorship, and career opportunities.
        </Paragraph>

        <Steps direction="horizontal" current={3} style={{ marginBottom: "40px" }}>
          <Step title="Join JectHub" icon={<SolutionOutlined style={{ color: "#1890ff" }} />} description="Sign up and create your profile." />
          <Step title="Engage & Learn" icon={<ReadOutlined style={{ color: "#1890ff" }} />} description="Access projects, challenges, and mentorship." />
          <Step title="Collaborate & Network" icon={<TeamOutlined style={{ color: "#1890ff" }} />} description="Connect with experts and peers." />
          <Step title="Get Certified & Hired" icon={<CheckCircleOutlined style={{ color: "#1890ff" }} />} description="Earn certifications and job opportunities." />
        </Steps>

        <Row gutter={[16, 16]} justify="center">
          {[
            { title: "Step 1: Join JectHub", description: "Sign up, create your profile, and start exploring the platform." },
            { title: "Step 2: Engage & Learn", description: "Participate in real-world challenges, access courses, and get hands-on experience." },
            { title: "Step 3: Collaborate & Network", description: "Work with peers, join discussions, and get mentorship from industry experts." },
            { title: "Step 4: Get Certified & Hired", description: "Earn industry-recognized certifications and gain access to job opportunities." },
          ].map((step, index) => (
            <Col xs={24} sm={12} md={8} lg={6} key={index}>
              <Card
                title={<span style={{ color: "#333" }}>{step.title}</span>}
                hoverable
                style={{
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
                headStyle={{ background: "#e6f7ff", borderBottom: "none" }}
                bodyStyle={{ padding: "16px" }}
              >
                <Paragraph style={{ color: "#666", fontSize: "14px" }}>
                  {step.description}
                </Paragraph>
              </Card>
            </Col>
          ))}
        </Row>
      </Content>
    </Layout>
  );
};

export default OurProcess;